import React, { FunctionComponent } from 'react';
import { ThemeModeProvider } from '@rbx/settings';
import { useRobloxAuthentication } from '@rbx/auth';
import { bedev2BaseUrl } from '@modules/utilities/constants/baseUrl';
import ModeResponsiveThemeProvider from './ModeResponsiveThemeProvider';

const AuthenticatedThemeModeProvider: FunctionComponent<
  React.PropsWithChildren<{ themeElement?: HTMLElement }>
> = ({ themeElement, children }) => {
  const { user: authenticatedUser } = useRobloxAuthentication();
  return (
    <ThemeModeProvider bedev2BaseUrl={bedev2BaseUrl} currentUser={authenticatedUser}>
      <ModeResponsiveThemeProvider themeElement={themeElement}>
        {children}
      </ModeResponsiveThemeProvider>
    </ThemeModeProvider>
  );
};

export default AuthenticatedThemeModeProvider;
